import { flowstepUIControl } from "@v2/types/data";
import { useEffect, useState } from "react";

type Input<T> = flowstepUIControl<T, T>["data"];
const isFunction = <T>(input: Input<T>): input is () => Promise<T> => {
  return typeof input === "function";
};

const useDataLoader = <T>(dataOrLoader: Input<T>): T | null => {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    let isMounted = true;

    if (isFunction<T>(dataOrLoader)) {
      dataOrLoader().then(
        (data) =>
          //prevent updating unmountend component
          isMounted && setData(data)
      );
    } else {
      setData(dataOrLoader);
    }

    return () => {
      isMounted = false;
    };
  }, [dataOrLoader]);

  return data;
};

export default useDataLoader;
